import React from 'react';
import styles from './input.module.css';

type TProps = JSX.IntrinsicElements['input'] & {
  extraClass?: string;
  inputWithBtn?: boolean;
  inputRef?: string | null;
}

export const Input = ({
  type,
  placeholder,
  inputWithBtn,
  extraClass,
  inputRef,
  value,
  onChange,
  ...props
}: TProps) => {
  const className = `${styles.input} ${extraClass} ${inputWithBtn ? styles.input_withBtn : ''}`;
  return (
    <input
      type={type}
      className={className}
      placeholder={placeholder}
      ref={inputRef}
      value={value}
      onChange={onChange}
      {...props}
    />
  );
};
